module.exports = __webpack_public_path__ + "static/tpp-image01-1-a471aa366981d17d90d0aa730c803e19.png";